import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrivyAuth from '../../util/PrivyAuth';
import { Button } from '../ui/button';
import { StyledButton } from '../ui/StyledButton';
import { ArrowBigLeft, Wallet } from 'lucide-react';

export const StoreHeader = () => {
  const navigate = useNavigate();
  const [walletStatus, setWalletStatus] = React.useState('');

  const handleConnect = (address) => {
    setWalletStatus(`已连接 Connected: ${address.slice(0, 6)}...${address.slice(-4)}`);
  };

  const handleDisconnect = () => {
    setWalletStatus('');
  };

  const handleStatusChange = (status) => {
    setWalletStatus(status);
  };

  return (
    <header className="w-full border-b-4 border-border bg-white">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo/Branding */}
          <div className="flex items-center gap-4">
            <h1 className="text-3xl font-heading text-text cursor-pointer" onClick={() => navigate('/')}>
              币安歌子店铺 Binagotchi Store
            </h1>
          </div>

          {/* Wallet Connection */}
          <div className="flex items-center gap-4">
            {walletStatus && (
              <div className="px-4 py-2 bg-main rounded-base border-2 border-border">
                <span className="text-sm font-base flex flex-center"><Wallet/><span className="ml-2">{walletStatus}</span></span>
              </div>
            )}
            <PrivyAuth
              onConnect={handleConnect}
              onStatusChange={handleStatusChange}
              onDisconnect={handleDisconnect}
            />
                
            
            <StyledButton className="text-pink-300"  
              onClick={() => navigate('/')}>
              
              <div className="flex flex-center"><ArrowBigLeft className="text-pink" /> <span className="ml-2 text-pink">返回游戏 (Back to Game)</span></div>
            </StyledButton>
          </div>
        </div>
      </div>
    </header>
  );
};
